<template>
  <!-- 开发任务列表 -->
  <el-container class="research">
    <el-main>
      <div class="toolbar">
        <div class="tl">
          <el-button type="primary" size="mini" class="bg" @click="add()">
            <i class="el-icon-plus"></i> 新增
          </el-button>

          <el-date-picker
            type="date"
            placeholder="提起日开始"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            v-model="query.bd"
            class="i150"
          ></el-date-picker>
          <span>-</span>

          <el-date-picker
            type="date"
            placeholder="提起日结束"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            v-model="query.ed"
            class="i150"
          ></el-date-picker>

          <!-- <el-input
            v-model="query.crman"
            placeholder="提出人"
            size="instructionsall"
            class="i150"
          /> -->
          <el-select
            clearable
            filterable
            v-model="query.crman"
            placeholder="提出人"
            class="i150"
          >
            <el-option v-for="o in crmanList" :key="o" :label="o" :value="o">
            </el-option>
            <el-option v-for="o in fzrList" :key="o" :label="o" :value="o">
            </el-option>
          </el-select>
          <el-input
            v-model="query.name"
            placeholder="客户名称"
            size="instructionsall"
            class="i150"
          />

          <el-select
            clearable
            filterable
            v-model="query.status"
            placeholder="请选开发状态"
            class="i150"
          >
            <el-option v-for="o in status" :key="o" :label="o" :value="o">
            </el-option>
          </el-select>

          <!-- <el-input
            v-model="query.fzr"
            placeholder="开发负责人"
            size="instructionsall"
            class="i150"
          /> -->
          <el-select
            clearable
            filterable
            v-model="query.fzr"
            placeholder="开发负责人"
            class="i150"
          >
            <el-option v-for="o in fzrList" :key="o" :label="o" :value="o">
            </el-option>
          </el-select>
          <el-select
            clearable
            filterable
            v-model="query.khtype"
            placeholder="开发类别"
            class="i150"
          >
            <el-option v-for="o in khtype" :key="o" :label="o" :value="o">
            </el-option>
          </el-select>
          <el-input
            v-model="query.contant"
            placeholder="开发内容"
            size="instructionsall"
            class="i150"
          />
          <el-button size="mini" type="primary" @click="getTable">
            搜索
          </el-button>
          <el-button
            size="mini"
            type="info"
            v-if="autoid != '0'"
            @click="gotojd"
          >
            返回项目进度
          </el-button>
          <el-button
            size="mini"
            type="warning"
            @click="b4tbtxwd"
            v-if="['黄桥', '赖柏均'].indexOf(userInfo.name) > -1"
          >
            同步腾讯文档
          </el-button>
        </div>
      </div>

      <el-tabs v-model="activeName" @tab-click="getTable">
        <el-tab-pane label="所有" name="所有"></el-tab-pane>
        <el-tab-pane label="进行中" name="进行中"></el-tab-pane>
        <el-tab-pane label="已完成" name="已完成"></el-tab-pane>
        <el-tab-pane label="已过期" name="已过期"></el-tab-pane>
      </el-tabs>
      <div class="tablemode">
        <el-table
          ref="table"
          border
          stripe
          v-loading="tableload"
          highlight-current-row
          :data="
            tableData.slice(
              (currentPage - 1) * pageSize,
              currentPage * pageSize
            )
          "
          tooltip-effect="dark"
          header-row-class-name="table_header"
          :header-row-style="{ 'text-align': 'center' }"
          @selection-change="handleSelectionChange"
          @row-dblclick="handRowdbClick"
          :cell-style="{ textAlign: 'center' }"
          style="width: 100%"
          height="100%"
        >
          <el-table-column
            v-for="(item, i) in th"
            :key="i"
            :label="item.chnname"
            :width="item.width"
            align="center"
            show-overflow-tooltip
            :column-key="item.fieldname"
            :filters="filters[item.fieldname]"
            :filter-method="filterHandler"
            :sortable="item.sortable"
            :prop="item.fieldname"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.isEdit">
                <el-switch
                  v-if="item.switch"
                  v-model="scope.row[item.fieldname]"
                  active-color="#1890FF"
                  inactive-color="#999999"
                ></el-switch>
                <el-select
                  clearable
                  v-else-if="item.select"
                  v-model="scope.row[item.fieldname]"
                  :filterable="item.canedit"
                  :allow-create="item.canedit"
                  :default-first-option="item.canedit"
                  placeholder="请选择状态"
                >
                  <el-option
                    v-for="item in tboptions[item.fieldname]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input
                  v-else-if="item.number"
                  v-model="scope.row[item.fieldname]"
                  oninput="value=value.replace(/\D/g,'')"
                />
                <el-date-picker
                  v-else-if="item.datetime"
                  type="date"
                  placeholder="选择日期"
                  v-model="scope.row[item.fieldname]"
                  style="width: 100%;"
                ></el-date-picker>
                <el-input
                  v-else
                  v-model="scope.row[item.fieldname]"
                  :disabled="item.disabled"
                />
              </template>

              <span v-else>{{
                item.switch
                  ? scope.row[item.fieldname]
                    ? '是'
                    : '否'
                  : item.select
                  ? scope.row['name'] ||
                    '无' + '-' + (scope.row['ctname'] || '')
                  : scope.row[item.fieldname]
              }}</span>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column
            :label="'操作'"
            width="100"
            fixed="right"
            class-name="operateColumn"
          >
            <template slot-scope="scope">
              <span
                v-if="userInfo.rootty"
                class="table_operate"
                :title="scope.row.isEdit ? '保存' : '删除'"
                @click="
                  tableOperate(
                    scope.$index,
                    scope.row,
                    scope.row.isEdit ? 'save' : 'delete'
                  )
                "
              >
                <svg-icon
                  :icon-class="
                    scope.row.isEdit
                      ? 'advancedQuerySave'
                      : 'advancedQueryDelete'
                  "
                />
              </span>
              <span class="divid">|</span>
              <span
                class="table_operate"
                :title="scope.row.isEdit ? '取消编辑' : '编辑'"
                @click="
                  tableOperate(
                    scope.$index,
                    scope.row,
                    scope.row.isEdit ? 'cancel' : 'edit'
                  )
                "
              >
                <svg-icon
                  :icon-class="
                    scope.row.isEdit
                      ? 'advancedQueryCancel'
                      : 'advancedQueryEdit'
                  "
                />
              </span>
              <span class="divid">|</span>
              <span
                class="table_operate"
                :title="'附件'"
                @click="tableOperate(scope.$index, scope.row, 'file')"
              >
                <svg-icon :icon-class="'img100059'" />
              </span>
              <span
                class="divid"
                v-if="
                  !scope.row.ischeck &&
                    scope.row.crman == userInfo.name &&
                    scope.row.status == '已完成'
                "
                >|</span
              >
              <span
                v-if="
                  !scope.row.ischeck &&
                    scope.row.crman == userInfo.name &&
                    scope.row.status == '已完成'
                "
                class="table_operate"
                :title="'提出人审核操'"
                @click="tableOperate(scope.$index, scope.row, 'check')"
              >
                <svg-icon :icon-class="'img100068'" />
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div class="footer">
          <el-pagination
            background
            align="right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[15, 20, 50, 100, 200, 300, 400, 500]"
            :page-size="pageSize"
            layout="prev, pager, next, sizes,jumper,total"
            :total="tableData.length"
          ></el-pagination>
        </div>
      </div>
    </el-main>
    <!-- 表单 -->
    <veaDialog
      :title="title"
      class="reForm"
      :show.sync="showre"
      :before-close="closeDialogre"
    >
      <el-form ref="form" :model="form" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="开发类别">
              <el-select
                clearable
                filterable
                v-model="form.khtype"
                placeholder="请选开发类别"
              >
                <el-option v-for="o in khtype" :key="o" :label="o" :value="o">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="期望完成日期">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                v-model="form.qwdate"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="开发主题">
          <el-input v-model="form.title" placeholder="请输入"> </el-input>
        </el-form-item>

        <el-form-item label="开发内容详细说明">
          <!-- <el-input v-model="form.contant" type="textarea" rows="20"></el-input> -->
          <UE :defaultMsg="form.contant" :config="config" ref="ue"></UE>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" rows="20"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开发状态">
              <el-select
                clearable
                filterable
                v-model="form.status"
                placeholder="请选开发类别"
              >
                <el-option v-for="o in status" :key="o" :label="o" :value="o">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开发负责人" required>
              <!-- <el-input v-model="form.fzr" placeholder="请输入"> </el-input> -->
              <el-select
                clearable
                filterable
                v-model="form.fzr"
                placeholder="开发负责人"
              >
                <el-option v-for="o in fzrList" :key="o" :label="o" :value="o">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开发预计完成日期">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                v-model="form.yjdate"
                style="width: 100%;"
                :disabled="['黄桥', '罗宇庆'].indexOf(userInfo.name) == -1"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实际完成日期">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                v-model="form.sjdate"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="开发备注说明">
          <el-input v-model="form.remark2" type="textarea" rows="20"></el-input>
        </el-form-item>
      </el-form>
    </veaDialog>

    <veaDialog
      title="选择月份"
      :show.sync="showyf"
      :before-close="closeDialoyf"
      :class="{ kfDialog: true }"
      confirmButtonText="确定"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="月份">
          <el-select clearable v-model="yymm" placeholder="请选择月份">
            <el-option
              v-for="item in yymmArr"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </veaDialog>
    <filelist
      ref="filelist"
      :ty="0"
      :choos="{ name: '二次开发' }"
      :pautoid="tablerow.autoid"
    />
  </el-container>
</template>

<script>
import { parseTime } from '@/utils'
import { createGguid } from '@/assets/js/pubMethods'
import {
  Edit_tpr_erkai,
  Query_tpr_erkai,
  GetFZRlist,
  GetKFlist,
  checkToken
} from '@api/api.js'
import filelist from '@components/filelist.vue'
import UE from '@components/ue.vue'
export default {
  components: {
    filelist,
    UE
  },
  data() {
    return {
      config: {
        // UEDITOR_HOME_URL: '/static/ueditor/',
        initialFrameWidth: null,
        initialFrameHeight: 700
      },
      autoid: this.$route.query.autoid,
      name: this.$route.query.name,
      userInfo: JSON.parse(sessionStorage.userInfo) || {},
      tablerow: {},
      tableChange: true,
      mode: 1,
      defaultProps: [],
      defalut: [],
      data: [], // 左边阶段-任务菜单
      input: '',
      value: '',
      currentPage: 1,
      pageSize: 15,
      query: {
        bd: parseTime(new Date(), '{y}-{m}-')+'01',
        ed: parseTime(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0), '{y}-{m}-{d}'),
        crman: '',
        name: '',
        status: '',
        fzr: '',
        contant: '',
        khtype: ''
      },
      th: [
        {
          chnname: '项目名称',
          fieldname: 'mautoid',
          width: '100',
          select: true
        },
        {
          chnname: '开发类别',
          fieldname: 'khtype',
          width: '100'
        },
        {
          chnname: '提出人',
          fieldname: 'crman',
          width: '100'
        },
        {
          chnname: '提出日期',
          fieldname: 'crdate',
          width: '120',
          sortable: true
        },
        {
          chnname: '期望完成日期',
          fieldname: 'qwdate',
          width: '140',
          sortable: true
        },
        {
          chnname: '开发主题',
          fieldname: 'title',
          width: '300'
        },
        // {
        //   chnname: '开发内容详细说明',
        //   fieldname: 'contant',
        //   width: '200'
        // },
        {
          chnname: '进度状态',
          fieldname: 'jdzt',
          width: '100'
        },
        {
          chnname: '开发状态',
          fieldname: 'status',
          width: '100'
        },

        {
          chnname: '开发负责人',
          fieldname: 'fzr',
          width: '100'
        },
        {
          chnname: '开发预计完成日期',
          fieldname: 'yjdate',
          width: '160',
          sortable: true
        },
        {
          chnname: '实际完成日期',
          fieldname: 'sjdate',
          width: '140',
          sortable: true
        },
        {
          chnname: '开发备注说明',
          fieldname: 'remark2',
          width: '140'
        },
        {
          chnname: '审核状态',
          fieldname: 'ischeck',
          width: '100',
          switch: true
        },
        {
          chnname: '备注',
          fieldname: 'remark',
          width: '60'
        }
      ],
      ini: [], // 原始的项目调研数据
      tableData: [], //筛选后显示的数据
      tableload: false,
      proptype: '',
      prolistchoos: {},
      form: {
        autoid: '0',
        mautoid: '0',
        khtype: '',
        title: '',
        contant: '',
        qwdate: parseTime(new Date(), '{y}-{m}-{d}'),
        yjdate: parseTime(new Date(), '{y}-{m}-{d}'),
        sjdate: null,
        status: '',
        fzr: '',
        remark: '',
        remark2: '',
        isactive: 1,
        isadd: 1
      },
      show: false,
      showre: false,
      title: '',
      form1: {},
      khtype: [
        '客户需求',
        '标准化',
        '开发内部任务',
        '开发周总结',
        '开发月总结'
      ],
      status: [
        '未开始',
        '开发中',
        '已修复',
        '已完成',
        '复测不通过',
        '无需处理'
      ],
      crmanList: [],
      fzrList: [],
      activeName: '所有',
      showyf: false,
      yymm: parseTime(new Date(), '{y}{m}')
    }
  },
  computed: {
    yymmArr() {
      let arr = [],
        lastMonth = new Date()
      lastMonth.setMonth(lastMonth.getMonth() + 1)
      for (let index = 0; index < 7; index++) {
        lastMonth.setMonth(lastMonth.getMonth() - 1)
        arr.push(parseTime(lastMonth, '{y}{m}'))
      }

      return arr
    }
  },
  watch: {
    '$route.query': {
      handler(newVal, oldVal) {
        this.autoid = newVal.autoid
        this._Query_tpr_erkai()
      },
      deep: true
    }
  },
  created() {
    this._Query_tpr_erkai()
    this._GetFZRlist()
    this._GetKFlist()
  },
  methods: {
    _GetKFlist() {
      GetKFlist().then(res => {
        this.fzrList = res.list.map(e => {
          return e.empname
        })
      })
    },
    _GetFZRlist() {
      GetFZRlist().then(res => {
        this.crmanList = res.list.map(e => {
          return e.empname
        })
      })
    },
    b4tbtxwd() {
      this.showyf = true
    },
    closeDialoyf(a) {
      if (a == 'confirm') {
        this.tbtxwd()
      }
      this.showyf = false
    },
    tbtxwd() {
      //http://hyclound.cn/apicloud/checkToken?key=228befcd9dec409f806e78d277ab10a3&code=
      checkToken({
        key: '228befcd9dec409f806e78d277ab10a3',
        yymm: this.yymm
      }).then(res => {
        this.$message.success('同步成功')
        this._Query_tpr_erkai() // 获取列表
      })
    },
    gotojd() {
      let path = '/main/project/progress'
      let query = {
        autoid: this.autoid,
        name: this.name
      }
      this.$router.push({ path: path, query: query })
    },
    filters() {
      let obj = {}
      this.th.forEach(e => {
        obj[e.fieldname] = Array.from(
          new Set(
            this.tableData.map(row => {
              return row[e.fieldname] || ''
            })
          )
        ).map(val => {
          return { text: val || '', value: val || '' }
        })
      })
      return obj
    },
    //表头筛选
    filterHandler(value, row, column) {
      //console.log(value, row, column, 'filterHandler')
      const property = column['columnKey']
      return row[property] === value
    },
    _Query_tpr_erkai() {
      this.ini = []
      Query_tpr_erkai({ mautoid: this.autoid })
        .then(res => {
          res.list.forEach(e => {
            e.yjdate = e.yjdate ? e.yjdate.split('T')[0] : ''
            e.sjdate = e.sjdate ? e.sjdate.split('T')[0] : ''
            e.qwdate = e.qwdate ? e.qwdate.split('T')[0] : ''
            e.crdate = e.crdate ? e.crdate.split('T')[0] : ''
          })
          this.ini = res.list
        })
        .finally(() => this.getTable())
    },
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    // 表格 操作方法
    tableOperate(index, row, type) {
      // this.curRow = row // 用currentChange 会导致打开 UserList 时 curRow还是空值，所以同意改成同一个方法赋值 this.curRow
      console.log('tableOperate', { index, row, type })
      // 编辑
      if (type == 'edit') {
        // row.isEdit = true
        // this.$forceUpdate()

        this.title = '修改二开项目'
        this.showre = true
        this.form = row
        this.form.isadd = 0
      } else if (type == 'cancel') {
        row.isEdit = false
        // 还原数据: 刷选上次接口返回的数据
        this.ini.forEach(el => {
          if (row.autoid == el.autoid) {
            let obj = JSON.parse(JSON.stringify(el))
            Object.assign(row, obj)
            this.$forceUpdate()
          }
        })
      } else if (type == 'save') {
        // 修改
        row.isactive = 1
        row.isadd = false
        Edit_tpr_erkai(row).then(res => {
          this.$message.success('修改成功')
          row.isEdit = false
          this._Query_tpr_erkai() // 获取列表
        })
      } else if (type === 'file') {
        this.tablerow = row
        this.$refs.filelist.show = true
      } else if (type === 'delete') {
        if (row.ischeck1 || row.ischeck2) {
          this.$message.warning('记录已审核，无法删除')
        } else {
          // 删除
          this.$confirm('您确定更要删除该记录吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            row.isEdit = false
            Edit_tpr_erkai({
              autoid: row.autoid,
              isactive: 0,
              isadd: false
            }).then(res => {
              this.$message.success('删除成功')
              this._Query_tpr_erkai() // 获取列表
            })
          })
        }
      } else if (type === 'check') {
        if (this.userInfo.kf) {
          this.$message.warning('只有非开发人员能审核')
        } else {
          // 审核
          this.$confirm('您确定更要审核该记录吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            row.isEdit = false
            Edit_tpr_erkai({
              autoid: row.autoid,
              isactive: 9,
              isadd: false
            }).then(res => {
              this.$message.success('审核成功')
              this._Query_tpr_erkai() // 获取列表
            })
          })
        }
      }
    },
    handRowdbClick(row) {
      this.tableOperate(0, row, 'edit')
    },
    handleSelectionChange(val) {
      this.tableChange = val
    },
    add() {
      this.title = '新增二开项目'
      this.showre = true
      this.form = {
        autoid: 0,
        mautoid: this.autoid,
        khtype: '',
        title: '',
        contant: '',
        qwdate: parseTime(new Date(), '{y}-{m}-{d}'),
        yjdate: parseTime(new Date(), '{y}-{m}-{d}'),
        sjdate: null,
        status: '',
        fzr: '',
        remark: '',
        remark2: '',
        isactive: 1,
        isadd: 1
      }
    },
    // 项目调研
    closeDialogre(a) {
      if (a == 'confirm') {
        // 保存
        this.form.crman = this.userInfo.name
        this.form.contant = this.$refs.ue.getUEContent()
        if (!this.form.fzr) {
          this.$message.error('开发负责人不能为空！')
          return
        }
        Edit_tpr_erkai(this.form)
          .then(res => {
            if (res.error == '0') {
              this.$message.success('保存成功')
              this.showre = false
            } else {
              this.$message.error(res.errorinfo)
            }
          })
          .finally(res => {
            this._Query_tpr_erkai()
          })
      } else {
        this.showre = false
      }
    },
    getTable() {
      this.tableData = this.ini.filter(e => {
        // 顶部搜索
        let b = {
          bd: true,
          ed: true,
          crman: true,
          name: true,
          status: true,
          fzr: true,
          contant: true,
          jdzt: true,
          khtype: true
        }
        if (this.query.bd) {
          b.bd = e.crdate >= this.query.bd
        }
        if (this.query.ed) {
          b.ed = e.crdate <= this.query.ed
        }
        if (this.query.crman) {
          b.crman = e.crman == this.query.crman
        }
        if (this.query.name) {
          b.name = e.name.indexOf(this.query.name) > -1
        }
        if (this.query.status) {
          b.status = e.status == this.query.status
        }
        if (this.query.fzr) {
          b.fzr = e.fzr == this.query.fzr
        }
        if (this.query.khtype) {
          b.khtype = e.khtype == this.query.khtype
        }
        if (this.query.contant) {
          b.contant = e.contant.indexOf(this.query.contant) > -1
        }
        if (this.activeName != '所有') {
          b.jdzt = e.jdzt == this.activeName
        }
        // 权限
        let root = false
        if (this.userInfo.director) root = true
        // 项目总监，开发经理、总监可以看到所有信息
        else if (this.userInfo.kf) {
          // 开发工程师：能看到自己提出或“开发负责人”为本人的记录项；
          root = e.fzr == this.userInfo.name || e.crman == this.userInfo.name
        } else {
          /*
            1.普通工程师：只能看到自己客户或自己提出的开发记录项；
            2.项目经理：只能看到自己或下属客户或自己提出的开发记录项；
          */
          root =
            e.Service_Manager == this.userInfo.name ||
            e.ServiceMan == this.userInfo.name ||
            e.ServiceMan2 == this.userInfo.name ||
            e.ServiceMan3 == this.userInfo.name ||
            e.crman == this.userInfo.name
        }
        if (b.fzr) console.log(111, b, e, root, this.userInfo)

        return (
          b.bd &&
          b.ed &&
          b.crman &&
          b.name &&
          b.status &&
          b.fzr &&
          b.contant &&
          b.jdzt &&
          b.khtype &&
          root
        )
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.el-container.research {
  background: #fff;
  border-radius: 10px;
  height: 100%;
  .el-aside {
    height: 100%;
    border-right: 1px solid #e5e5e5;
    .head {
      height: 80px;
      border-bottom: 1px solid #e5e5e5;
      display: flex;
      align-items: center;
      font-size: 25px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      padding: 0 10px;
      i {
        color: #fff;
        background: rgba(0, 127, 245, 1);
        border-radius: 50%;
        padding: 5px;
        font-size: 12px;
        margin-right: 10px;
      }
    }
    .el-menu {
      height: calc(100% - 130px);
      /deep/ .el-menu-item-group__title {
        display: none;
      }
      /deep/ .el-submenu__title,
      .el-menu-item {
        height: 30px;
        line-height: 30px;
      }
      /deep/ .or {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: bold;
        font-size: 18px;
        padding-right: 15px;
        .ico1 {
          color: #333;
        }
        .ico2 {
          color: rgba(0, 127, 245, 1);
        }
        .ps {
          font-size: 14px;
          font-weight: normal;
          color: #999;
        }
      }
    }
    .footer {
      padding: 0 10px;
      .bg {
        width: 170px;
      }
    }
  }
  .el-main {
    .toolbar {
      display: flex;
      justify-content: space-between;
      .tl {
        display: flex;
        span {
          display: flex;
          padding: 0 5px;
          align-items: center;
        }
        .i150 {
          width: 150px;
          margin: 5px;
        }
      }
    }
    .tablemode {
      height: calc(100vh - 250px);
      .footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 20px;
      }
      .el-table {
        // 工具栏
        /deep/ .hidden-columns {
          visibility: inherit;
          z-index: 9999;
          right: 7px;
          // margin-top: 3px;
          .my_tools {
            height: 100%;
            min-width: 45px;
            max-width: 100%;
            // padding: 0 0 0 20px;
            padding: 0 25px 0 20px;
            background: linear-gradient(
              to right,
              rgba(0, 0, 0, 0) 0%,
              #eee 30px,
              #ccc 100%
            );
            position: relative;
            .tools_box {
              @include wh(100%, 100%);
              display: flex;
              align-items: center;
              overflow: auto;
              .el-button {
                // 工具栏 内容字体大小随表单（后台控制）PS：目前只用到button，后期有需要其他再另行补充
                // @include _font;
                width: 100%;
                height: 100%;
                font-size: 12px;
                // display: flex;
                // flex-direction: column;
                // align-items: center;
                svg {
                  display: block;
                  margin: 2px auto;
                }
              }
            }
            // 隐藏按钮
            .hide_btn {
              position: absolute;
              top: 0;
              right: 0;
              @include wh(20px, 100%);
              @include flexCenter;
              border-left: 1px solid transparent;
              transition: all 0.2s;
              &:hover {
                // background: #ccc;
                background: #aaa;
                cursor: pointer;
                // border-left-color: #FFF;
                color: #fff;
              }
            }
          }
          .hide {
            transition: all 0.3s;
            svg {
              transform: rotate(180deg);
            }
          }
        }
      }
    }
    .el-container.formmode {
      height: calc(100vh - 290px);
      .el-aside {
        height: 100%;
        background: #eee;
        padding: 10px 0;
        .prolist {
          padding: 0 10px;
          font-size: 18px;
          height: 30px;
          display: flex;
          align-items: center;
          cursor: pointer;
          .ico {
            display: inline-block;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: #1890ff;
            margin-right: 5px;
            visibility: hidden;
          }
        }
        .prolist.isactive {
          background: lightblue;
          color: #1890ff;
          .ico {
            visibility: visible;
          }
        }
      }
      .el-main {
        height: 100%;
        overflow-y: auto;
        .formhead {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px;
          .title {
            color: #000;
            font-size: 20px;
            font-weight: bold;
            span {
              font-size: 25px;
            }
          }
        }
        .form {
          // background: #000;
          overflow-y: auto;
          height: calc(100% - 110px);
        }
        .foot {
          display: flex;
          justify-content: end;
        }
      }
    }
  }
}
.reCHForm,
.reForm {
  /deep/ .el-dialog {
    @include wh(99vw, 99vh);

    .el-dialog__body {
      padding: 10px;
      height: 100%;
      overflow-y: scroll;
    }
  }
}
/deep/ .el-form-item {
  .el-form-item__label {
    font-weight: bold;
  }
}
.kfDialog {
  /deep/ .el-dialog {
    @include wh(500px, 170px);
    .el-dialog__body {
      padding: 10px;
      .el-form-item {
        margin-bottom: 0;
      }
      .el-select {
        width: 100%;
      }
      .i150 {
        width: calc(50% - 1em);
      }
    }
  }
}
</style>
